import { Box, Flex } from "@chakra-ui/react"

/**
 * PUBLIC page: esoportal.io/sms-terms. Linked from every SMS consent disclosure ("See our SMS
 * Terms") and required by carriers for toll-free verification and 10DLC registration.
 * Content follows eso_context/SMS_COMPLIANCE.md (CTIA program terms). Keep it in step with
 * the consent copy in portal-backend src/services/smsConsentCopy.ts.
 */

const h2: React.CSSProperties = { fontSize: 17, fontWeight: 700, margin: "22px 0 6px", color: "#1f4e79" }
const p: React.CSSProperties = { margin: "0 0 10px", fontSize: 15, lineHeight: 1.6, color: "#2d3748" }

export const SmsTermsPage = () => (
  <Flex minH="100vh" bg="#f4f6f8" justify="center" align="flex-start" py={{ base: 6, md: 16 }} px={4}>
    <Box bg="white" borderRadius="8px" boxShadow="sm" p={{ base: 6, md: 10 }} w="100%" maxW="720px">
      <h1 style={{ fontSize: 26, fontWeight: 700, margin: "0 0 4px", color: "#1f4e79" }}>ESO Fund SMS Terms</h1>
      <p style={{ ...p, color: "#718096", fontSize: 13 }}>ESO Management Services LLC</p>

      <h2 style={h2}>What you'll receive</h2>
      <p style={p}>
        <strong>Sign-in codes</strong> from +1 681-252-5134: one-time passcodes and account-security alerts, one
        message each time you request a code.
      </p>
      <p style={p}>
        <strong>Service messages</strong> from +1 844-820-4194: texts about your inquiry or transaction with ESO Fund,
        such as replies to your questions, document and signature requests, funding and closing status, and payment
        updates. We do not send sales or promotional texts under this consent. Message frequency varies.
      </p>

      <h2 style={h2}>How to opt in and out</h2>
      <p style={p}>
        You opt in by ticking the SMS consent box at esoportal.io/sms-opt-in. Consent is not a condition of any purchase or financing. Reply <strong>STOP</strong> to any
        message to stop texts from that number; you'll get one confirmation and no further messages. Reply
        <strong> START</strong> to resubscribe. You can also opt out by emailing support@esofund.com.
      </p>

      <h2 style={h2}>Help</h2>
      <p style={p}>Reply <strong>HELP</strong> for help, or email support@esofund.com.</p>

      <h2 style={h2}>Costs and coverage</h2>
      <p style={p}>
        Message and data rates may apply. Texts are available to US and Canadian mobile numbers only. Carriers are not
        liable for delayed or undelivered messages.
      </p>

      <h2 style={h2}>Privacy</h2>
      <p style={p}>
        We use your mobile number only to send the messages described here. No mobile information will be shared with
        third parties or affiliates for marketing or promotional purposes. Text messaging opt-in data and consent will
        not be shared with any third parties. See our{" "}
        <a href="https://www.esofund.com/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: "#2b6cb0" }}>Privacy Policy</a>.
      </p>
    </Box>
  </Flex>
)
